document.addEventListener('DOMContentLoaded', function() {
  // 监听导航菜单加载完成
  setTimeout(function() {
    // 获取所有子菜单链接
    const subMenuLinks = document.querySelectorAll('.nav-dropdown__link');
    
    // 颜色映射配置
    const colorMap = {
      'Yellow': '#BFA50C',
      'Black': '#000000',
      'White': '#DADAE1',
      'Silver': '#DDDDDD'
    };
    
    // 遍历所有链接
    subMenuLinks.forEach(link => {
      const titleText = link.textContent.trim();
      
      // 检查是否包含需要处理的文本
      if (titleText.includes('[icon-')) {
        // 移除[icon-*]文本
        let cleanTitle = titleText.replace(/\[icon-[^\]]*\]/g, '').trim();
        
        // 检查清理后的标题是否匹配颜色映射中的关键词
        for (const [keyword, color] of Object.entries(colorMap)) {
          if (cleanTitle.includes(keyword)) {
            // 创建一个span元素用于显示颜色块
            const colorDot = document.createElement('span');
            colorDot.style.display = 'inline-block';
            colorDot.style.width = '12px';
            colorDot.style.height = '12px';
            colorDot.style.borderRadius = '50%';
            colorDot.style.marginRight = '8px';
            colorDot.style.verticalAlign = 'middle';
            colorDot.style.backgroundColor = color;
            
            // 清除链接内容并重新添加带颜色块的内容
            link.textContent = cleanTitle;
            link.prepend(colorDot);
            break;
          }
        }
      }
    });
  }, 500); // 延迟执行，确保菜单已完全加载
});